"use client";

import { Button } from "@/components/ui/button";
import { CBG_COMP_PACK_MANAGE_COOKIES_BUTTON_LABEL } from "@/utilities/cbgCompPackConfig";
import { openCbgManageCookies } from "@/utilities/openCbgManageCookies";

export function CbgManageCookiesButton() {
  const label =
    process.env.NEXT_PUBLIC_CBG_COMP_PACK_MANAGE_COOKIES_BUTTON_LABEL?.trim() ||
    CBG_COMP_PACK_MANAGE_COOKIES_BUTTON_LABEL;

  return (
    <Button
      className="w-fit self-start"
      colorMode="gold"
      size="lg"
      type="button"
      variant="default"
      onClick={() => openCbgManageCookies()}
    >
      {label}
    </Button>
  );
}
